module.exports = __webpack_public_path__ + "static/img/bg_Sky_2.c65123b8.jpg";